import { FC, useId } from 'react';

import { FormControl, FormControlBaseProps } from '../FormControl';

import { FormDatepickerValidation } from './FormDatepicker.types';
import { FormDatepickerInput } from './FormDatepickerInput/FormDatepickerInput';
import { FormDatepickerContext } from './FormDatepicker.context';

interface FormDatepickerProps
  extends FormControlBaseProps<FormDatepickerValidation> {
  placeholder?: string;
  defaultValue?: string;
}

export const FormDatepicker: FC<FormDatepickerProps> = ({
  defaultValue,
  placeholder,
  ...props
}) => {
  const id = useId();

  return (
    <FormControl variant="default" type="datepicker" {...props}>
      {({ ref, enterKeyHint, ...params }) => {
        return (
          <FormDatepickerContext.Provider
            value={{
              id,
              enterKeyHint,
              name: props.name,
              defaultValue,
              placeholder,
              ...params,
            }}
          >
            <FormDatepickerInput
              ref={ref}
              name={props.name}
              label={props.label}
            />
          </FormDatepickerContext.Provider>
        );
      }}
    </FormControl>
  );
};
